module.exports = __webpack_public_path__ + "static/img/brees-2014-top-image-thumb.c573935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2014-top-image-thumb.jpg
// module id = B0wm
// module chunks = 1